const icons = {
    approval: require("./approvals.svg").default,
    analytics: require("./analytics-icon.svg").default,
    orderManagement: require("./order_m.svg").default,
    supplyChain: require("./supply-chain-icon.svg").default,
    financeWorkingCap: require("./funds-line.svg").default,
    masterDataManagement: require("./building-2-line.svg").default,
    catalogManagement: require("./list-indefinite.svg").default,
    stakeholder: require("./shake-hands-line.svg").default,
    customerSupport: require("./user-star-line.svg").default,
    settingCustomization: require("./settings-4-line.svg").default,
  };
  export default icons;